var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:{ selected: _vm.selected },attrs:{"disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default"),(_vm.arrow)?_c('div',{staticClass:"arrow"},[_c('span'),_c('span')]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }